import { render, staticRenderFns } from "./GameScatterChartMobile.vue?vue&type=template&id=6c0f1262&scoped=true"
import script from "./GameScatterChartMobile.vue?vue&type=script&lang=js"
export * from "./GameScatterChartMobile.vue?vue&type=script&lang=js"
import style0 from "./GameScatterChartMobile.vue?vue&type=style&index=0&id=6c0f1262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f1262",
  null
  
)

export default component.exports